import { render, staticRenderFns } from "./MyOzone.vue?vue&type=template&id=fe452a52&"
import script from "./MyOzone.vue?vue&type=script&lang=js&"
export * from "./MyOzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports